/**
 * Bottom status bar — Ladestatus + Bedienungs-Hinweis.
 *
 * Der Hinweis verschwindet beim ersten Klick auf das Canvas, damit
 * er den Anwender nicht stört, sobald er anfängt zu arbeiten.
 */

interface StatusBarProps {
  message: string
  showHint: boolean
}

export function StatusBar({ message, showHint }: StatusBarProps) {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '0.5rem 1rem',
        background: 'rgba(0, 0, 0, 0.7)',
        color: '#ddd',
        fontFamily: 'ui-monospace, "SF Mono", monospace',
        fontSize: '0.85rem',
        display: 'flex',
        justifyContent: 'space-between',
        gap: '1rem',
        pointerEvents: 'none',
      }}
    >
      <div>{message}</div>
      {showHint && (
        <div style={{ opacity: 0.55, fontSize: '0.78rem' }}>
          Links: Verschieben · Mitte: Drehen · Mausrad: Zoom · Rechtsklick (im Werkzeug): Abschließen
        </div>
      )}
    </div>
  )
}
